import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import { ITabItem } from 'components/tab';
import React, { useState } from 'react';
import { TableViews } from '../constants';
import TableContainer from './tableContainer';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { useRMDispatch } from 'redux/hooks';
import { setSelectedRowIndices } from 'redux/reducers/searchnFilterReducer';
import { useHistory } from 'react-router';
const TablePanel = (props) => {
  const [panelState, setPanelState] = useState<TableViews>(TableViews.VIEW_TABLE);

  const dispatch = useRMDispatch();
  const history = useHistory();
  const onEditTable = () => {
    setPanelState(TableViews.EDIT_TABLE);
  };
  const rightSideButtonProps: RMCustomButtonProps[] = [
    {
      title: 'EDIT TABLE',
      contentContainerClass:
        'text-white bg-[#4CAF50] w-[96px] h-[26px] p-t-[4px] p-r-[10px] p-b-[4px] p-l-[10px] gap-2 font-roboto font-medium leading-[18px] ',
      onClick: onEditTable,
      isDisabled: false,
    },
  ];

  const customSelectionChange = (rowIndices) => {
    if (rowIndices.length > 1) {
      history.push('compare');
    }
    if (rowIndices.length > 0) {
      dispatch(setSelectedRowIndices(rowIndices));
    }
  };

  const tabItems_: ITabItem[] = [
    {
      content: (
        <TableContainer
          panelState={panelState}
          setPanelState={setPanelState}
          customSelectionChange={customSelectionChange}
        />
      ),
      title: 'Table',
    },
  ];
  return (
    <div id="searchandfilter-table-panel-wrapper">
      <BaseSidePanel
        tabItems={tabItems_}
        headerTitle={'Table'}
        {...{
          actionButtonsProps:
            panelState === TableViews.EDIT_TABLE ? [] : rightSideButtonProps,
        }}
      />
    </div>
  );
};

export default TablePanel;
